<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full grid grid-cols-1 gap">
    <div class="flex flex-col items-center gap-6">
        <h2>Ergebnisse sagen mehr als tausend Worte</h2>
        <p class="max-w-screen-sm text-center">
            Unsere Kunden wissen, wie wichtig es ist, digital zu überzeugen. Aber schau dir die
            Ergebnisse doch einfach selbst an.
        </p>
    </div>

    <!-- projects -->
    @if (items()) {
        @for (project of items(); track project) {
            <div class="w-full card muted !spacing-md grid grid-cols-1 xl:grid-cols-6 gap-6">
                <div class="xl:col-span-3">
                    <img loading="lazy" alt="" width="1440" height="900"
                         [src]="project.fields.cover!.fields.file!.url"
                         class="w-full h-full aspect-video object-cover rounded-medium border border-muted-dark"/>
                </div>

                <div class="xl:col-span-3 flex flex-col gap-6">
                    <p class="italic font-normal leading-tight text-dark text-lg">“Es sieht gut aus, es konvertiert - Top.
                        Die
                        Zusammenarbeit hat perfekt funktioniert. Der Support war super und ich konnte mich voll auf mein
                        Lokal konzentrieren.”</p>

                    <div class="flex flex-col gap-1">
                    <span class="font-normal text-dark">{{
                            project.fields.initialSituationHeading
                        }}</span>
                        <p>
                            {{ project.fields.initialSituationContent }}
                        </p>
                    </div>

                    <div class="flex flex-col gap-1">
                        <span class="font-normal text-dark">{{ project.fields.aimHeading }}</span>
                        <p>
                            {{ project.fields.aimContent }}
                        </p>
                    </div>

                    @if (project.fields.resultContent || project.fields.resultStatistics) {
                        <div
                            class="flex flex-col gap-1"
                            [class.!gap-4]="!!project.fields.resultStatistics">
                            @if (!project.fields.resultStatistics) {
                                <div
                                    class="bg-secondary-600 rounded-medium flex justify-between gap-6 flex-wrap p-6 xl:col-span-6">
                                    <p class="text-white">
                                        {{ project.fields.resultContent }}
                                    </p>
                                </div>
                            }
                        </div>
                    }
                </div>

                @if (project.fields.resultStatistics) {
                    <div
                        class="bg-secondary-600 rounded-medium flex justify-between gap-6 flex-wrap p-6 xl:col-span-6">
                        @for (stat of project.fields.resultStatistics; track stat) {
                            <div
                                class="flex flex-col font-lighter items-center md:items-end text-white">
                            <span class="text-4xl"
                            ><span
                                class="[&>span]:font-medium"
                                [innerHTML]="stat!.fields.value"></span
                            ><span class="text-3xl">{{ stat!.fields.unit }}</span></span
                            >
                                <span class="leading-none text-right text-md">{{
                                        stat!.fields.label
                                    }}</span>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    } @else {
        <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
            <div class="w-full h-full bg-gray-200 aspect-video"></div>
        </div>

        <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
            <div class="w-full h-full bg-gray-200 aspect-video"></div>
        </div>
    }
</div>
